/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Col, Row, Typography } from 'antd';

import {
  TextField,
  ColorField,
  YouTubeUrlField,
  ModeSelect,
  ArticlesByTagField,
  ArticlesByEventField,
  PositionField,
} from '@molecules';
import MediaField from '@organisms/MediaField';
import { Button } from '@atoms';
import { CAROUSEL_FIELDS, MODE, MODES, detectMode } from './constant';
import Form from '../Form';

const HeroSlidesForm = ({ onSubmit, initialValues: initData, buttons, className }) => {
  const [form] = Form.useForm(CAROUSEL_FIELDS);

  const initialValues = React.useMemo(() => form.deserialize(initData), [form, initData]);

  const [mode, setMode] = React.useState(detectMode(initialValues).value);

  const handleFinish = React.useCallback(
    (value) => {
      onSubmit(value, initData);
      form.resetFields();
    },
    [form, onSubmit, initData],
  );

  const handleSelectMode = React.useCallback(
    (_mode) => {
      setMode(_mode);
      form.resetFields([CAROUSEL_FIELDS.SLIDE_ARTICLE.name]);
    },
    [form],
  );

  return (
    <Form
      form={form}
      onSerializedFinish={handleFinish}
      labelAlign="left"
      layout="vertical"
      colon={false}
      initialValues={initialValues}
      className={className}
    >
      {buttons && <Typography.Text level={3}>Edit Slide</Typography.Text>}
      <ModeSelect
        mode={mode}
        onSelect={handleSelectMode}
        {...MODE}
        labelCol={{ span: 3 }}
        style={{ flexDirection: 'row', display: buttons ? 'none' : undefined }}
      />
      <Row>
        {mode === MODES.EXISTING.value && <ArticlesByEventField {...CAROUSEL_FIELDS.SLIDE_ARTICLE} isTypeFilter />}
        <Col flex="1" offset={mode !== MODES.TAG.value && !buttons && 3}>
          {mode === MODES.TAG.value && <ArticlesByTagField {...CAROUSEL_FIELDS.SLIDE_ARTICLE} />}
          {mode === MODES.MANUAL.value && (
            <Row>
              <Col flex="1">
                <TextField {...CAROUSEL_FIELDS.SLIDE_LOCATION} rules={null} />
                <MediaField {...CAROUSEL_FIELDS.SLIDE_IMAGE} />
                <TextField {...CAROUSEL_FIELDS.SLIDE_TITLE} />
                <TextField {...CAROUSEL_FIELDS.SLIDE_SUBTITLE} rules={null} />
                <TextField {...CAROUSEL_FIELDS.SLIDE_STANDFIRST} rules={null} />
              </Col>
            </Row>
          )}
          {mode === MODES.VIDEO.value && (
            <Row>
              <Col flex="1">
                <YouTubeUrlField {...CAROUSEL_FIELDS.SLIDE_VIDEO} />
                <MediaField {...CAROUSEL_FIELDS.SLIDE_IMAGE} />
                <TextField {...CAROUSEL_FIELDS.SLIDE_TITLE} />
                <TextField {...CAROUSEL_FIELDS.SLIDE_SUBTITLE} />
                <TextField {...CAROUSEL_FIELDS.SLIDE_STANDFIRST} />
              </Col>
            </Row>
          )}
          <Row>
            <Col flex="1">
              <Row gutter={40}>
                <Col span={8}>
                  <PositionField {...CAROUSEL_FIELDS.SLIDER_TEXT_POSITION} />
                </Col>
                <Col>
                  <ColorField {...CAROUSEL_FIELDS.SLIDE_TEXT_COLOR} />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col flex="1" gutter={10}>
              {buttons ? (
                buttons({ onSubmit: form.submit })
              ) : (
                <Button type="customBlue" style={{ minWidth: 200 }} onClick={form.submit}>
                  ADD SLIDE
                </Button>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};

export default HeroSlidesForm;
